import api from "../services/api";
import { IAccommodation } from "../models/IAccommodation";
import { IServiceResponse } from "../types/api";

export const getAccommodationsByTournament = (tournamentId: string): Promise<IServiceResponse<IAccommodation[]>> =>
  api.get(`accommodation/tournament/${tournamentId}`);

